/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/dastechnoteam/"

const dastechnoteam: CommunityData = {
  code: "dastechnoteam",
  inviteCode: "dastechnoteam",
  name: "Das Techno Team",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/das-991`,
  socials: {},
  waitlist: true,
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `https://media.werz.at/community-assets/dastechnoteam/mobile-landing-background.mp4?type=video`,
        mobile: `https://media.werz.at/community-assets/dastechnoteam/mobile-landing-background.mp4?type=video`,
        style: "bg-[#1a1a1a]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[140px] h-[27px] sm:w-[200px] sm:h-[38px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['NeutralFaceBold'] text-[28px] leading-[120%] text-[#ffffff]",
      text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-[#ffffff]",
      button:
        "font-['NeutralFaceBold'] text-[16px] leading-[100%] p-4 bg-[#ffffff] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#000000] text-[#ffffff]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D]",
      skipButton:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D] cursor-pointer",
      modal: {
        container: "bg-[#111111] px-[40px] py-[48px]",
        title: "font-['NeutralFaceBold'] text-[24px] leading-[120%] text-[#ffffff] text-center",
        text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8D8D8D] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#ffffff] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[200px] h-[38px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[200px] h-[38px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "border-r border-[#343434]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.png`,
      bgMobile: `${S3_PREFIX}web-background-mobile.png`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#ffffff] border-2 border-[#ffffff] px-[18px] py-[18px] !text-[#000000] font-['NeutralFaceBold'] !text-[16px] text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#343434]",
      separator: "border-[#343434]",
      item: "font-['NeutralFaceBold'] text-[14px] text-[#ffffff] text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#343434] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles: "text-[#ffffff] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#343434]",
        sectionTitle:
          "text-[#ffffff] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#ffffff] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#343434]",
        sectionTitle:
          "text-[#ffffff] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          subtitle:
            "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
          location:
            "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-1",
          date: "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#ffffff] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[18px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#343434]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#ffffff] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ffffff] border-2 border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['NeutralFaceBold'] !text-[16px] text-left leading-[100%]",
        questions: "text-[15px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#343434]",
        header: "text-[#ffffff] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#343434]",
        header: "text-[#ffffff] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#ffffff] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#ffffff] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#343434] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#ffffff] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%] mb-1",
          description:
            "text-[#a7a7a7] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#a7a7a7] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          quantity: "text-[#ffffff] font-['NeutralFaceBold'] text-[14px] text-left leading-[100%]",
          status: "text-[#a7a7a7] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ffffff] px-[16px] py-[12px] text-[#ffffff] font-['NeutralFaceBold'] text-[14px] text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default dastechnoteam
